import { render, staticRenderFns } from "./vsUpload.vue?vue&type=template&id=990a8932&scoped=true&"
import script from "./vsUpload.vue?vue&type=script&lang=js&"
export * from "./vsUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990a8932",
  null
  
)

export default component.exports